export function formatDuration (minutesInput) {
  if (!minutesInput || minutesInput <= 0) {
    return ''
  }

  const totalMinutes = Math.round(minutesInput)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (hours > 0 && minutes > 0) {
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`
  }

  if (hours > 0) {
    return `${hours} ${hours === 1 ? 'hour' : 'hours'}`
  }

  return `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`
}
